import React from 'react';
import { motion } from 'framer-motion';
import { TestTube, Layers, Settings } from 'lucide-react';
export function PhasesSection() {
  return <section className="h-full flex items-center py-8 px-4 sm:px-6 lg:px-8 bg-gray-50/50 overflow-y-auto lg:overflow-hidden" data-id="element-152">
      <div className="max-w-7xl mx-auto w-full" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-10 text-center" data-id="element-154">
          <span className="text-xs font-bold tracking-widest text-[#80BC41] uppercase mb-3 block" data-id="element-155">
            05 — Approach
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] font-heading" data-id="element-156">
            Validate first. Then scale.
          </h2>
        </motion.div>

        <div className="relative" data-id="element-157">
          <div className="hidden lg:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-gray-200" data-id="element-158"></div>

          <div className="grid lg:grid-cols-3 gap-6 relative z-10" data-id="element-159">
            {/* Phase 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1,
            ease: 'easeOut'
          }} className="relative flex flex-col items-center text-center" data-id="element-160">
              <div className="w-16 h-16 rounded-full bg-[#EB0A1E] text-white flex items-center justify-center mb-4 shadow-lg ring-8 ring-gray-50" data-id="element-161">
                <TestTube className="w-7 h-7" data-id="element-162" />
              </div>
              <h3 className="text-lg font-bold text-[#1a1a1a] mb-0.5" data-id="element-163">
                Phase 1
              </h3>
              <p className="text-xs font-bold uppercase tracking-wider mb-3 text-[#FFFFFF] bg-[#1A1A1A]" data-id="element-164">
                Next
              </p>
              <ul className="space-y-2 text-left w-full max-w-xs bg-white p-5 rounded-xl border-2 border-[#EB0A1E]/15 shadow-sm relative overflow-hidden" data-id="element-165">
                <div className="absolute top-0 left-0 w-1 h-full bg-[#EB0A1E]" data-id="element-166"></div>
                <li className="flex items-start gap-2" data-id="element-167">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#EB0A1E] mt-1.5 shrink-0" data-id="element-168"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-169">
                    Build 1 landing page (frontend only)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-170">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-171"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-172">
                    A/B comparison with existing page
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-173">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-174"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-175">
                    Same vehicle, comparable budget
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-176">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-177"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-178">
                    Measure conversion improvement
                  </span>
                </li>
              </ul>
            </motion.div>

            {/* Phase 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2,
            ease: 'easeOut'
          }} className="relative flex flex-col items-center text-center" data-id="element-179">
              <div className="w-16 h-16 rounded-full bg-white text-[#80BC41] border-2 border-[#80BC41]/30 flex items-center justify-center mb-4 ring-8 ring-gray-50" data-id="element-180">
                <Layers className="w-7 h-7" data-id="element-181" />
              </div>
              <h3 className="text-lg font-bold text-[#1a1a1a] mb-0.5" data-id="element-182">
                Phase 2
              </h3>
              <p className="text-xs text-[#80BC41] font-bold uppercase tracking-wider mb-3" data-id="element-183">
                CMS & Scale
              </p>
              <ul className="space-y-2 text-left w-full max-w-xs bg-white p-5 rounded-xl border border-gray-100 shadow-sm" data-id="element-184">
                <li className="flex items-start gap-2" data-id="element-185">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#80BC41] mt-1.5 shrink-0" data-id="element-186"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-187">
                    Deploy October CMS
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-188">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-189"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-190">
                    Scale across all offers and languages
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-191">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-192"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-193">
                    Centralized content management
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-194">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-195"></div>
                  <span className="text-gray-700 font-medium text-xs" data-id="element-196">
                    Full system rollout
                  </span>
                </li>
              </ul>
            </motion.div>

            {/* Phase 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3,
            ease: 'easeOut'
          }} className="relative flex flex-col items-center text-center" data-id="element-197">
              <div className="w-16 h-16 rounded-full bg-white text-gray-400 border-2 border-gray-200 flex items-center justify-center mb-4 ring-8 ring-gray-50" data-id="element-198">
                <Settings className="w-7 h-7" data-id="element-199" />
              </div>
              <h3 className="text-lg font-bold text-[#1a1a1a] mb-0.5" data-id="element-200">
                Phase 3
              </h3>
              <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-3" data-id="element-201">
                Maintenance
              </p>
              <ul className="space-y-2 text-left w-full max-w-xs bg-white p-5 rounded-xl border border-gray-100 border-dashed" data-id="element-202">
                <li className="flex items-start gap-2" data-id="element-203">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-204"></div>
                  <span className="text-gray-600 font-medium text-xs" data-id="element-205">
                    Hosting and server management
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-206">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-207"></div>
                  <span className="text-gray-600 font-medium text-xs" data-id="element-208">
                    CDN for image delivery
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-209">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300 mt-1.5 shrink-0" data-id="element-210"></div>
                  <span className="text-gray-600 font-medium text-xs" data-id="element-211">
                    System maintenance and updates
                  </span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}